var App = App || {};

App.Accordion = (function () {
    "use strict";

    function init()
    {
        openAnchorAccordion(location.hash.split('#')[1]);
    }

    function openAnchorAccordion(hash)
    {
        if (hash) {
            const target = document.getElementById(hash);
            if (target) {
                $(target).collapse('show');
                $('html, body').animate({
                    scrollTop: $(target).offset().top - 200
                }, 1000);
            }
        }
    }

    return {
        init: init
    };

})();

$(function () {
    App.Accordion.init();
});